import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UIModule } from '@c4/ui';

@Component({
  selector: 'sysman-network-config-dns',
  templateUrl: './dns-config.component.html'
})
export class SysmanNetworkConfigDNSComponent {

  @Input() name: string;
  @Input() tagId: string;
  @Input() nstype: string;
  @Input() ns1: string;
  @Input() ns2: string;
  @Input() ns3: string;

  @Output() valueChangeNStype: EventEmitter<string> = new EventEmitter<string>();
  @Output() valueChangeNS1: EventEmitter<string> = new EventEmitter<string>();
  @Output() valueChangeNS2: EventEmitter<string> = new EventEmitter<string>();
  @Output() valueChangeNS3: EventEmitter<string> = new EventEmitter<string>();

  nstypeOptions : Array<any> = [{name:"Obtain Automatically",value:"dhcp"},{name:"Use the following DNS",value:"static"}];

  constructor() { 
  }

}


// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/sysman-network-config/dns-config.component.ts